<template>
	<!-- <div class="construct-wrapper">
		<div class="construct flexBox">
			<img src="../../static/images/construct.svg">
			<h3>功能建设中</h3>
			<p>更新后可查看同类标签问题</p>
			<span @click="$router.go(-1)">我知道了</span>
		</div>
	</div> -->
	<div class="jjj">
		<iframe src="https://peoplestg.niohome.com/#/mine/C0524/franky.yang"></iframe>
	</div>
</template>

<script>
	import { COMMON } from '../api'
	export default {
		name: 'construct',
		data () {
			return {

			}
		},
		mounted () {
			// if (this.$route.params.tag) {
			// 	COMMON.Logger({
			// 		Event: 'tag'
			// 	}).then( (res) => {})
			// }
		}
	}
</script>

<style lang="scss" scoped>
	.jjj {
		height: 100%;
		iframe {
			height: 100%;
			width: 100%;
			border: none;
		}
	}
	.construct-wrapper {
		position: absolute;
		top: 0; bottom: 0;
		left: 0; right: 0;
		.construct {
			flex-direction: column;
			justify-content: center;
			height: 100%;
			img {
				width: j(200);
				height: j(162);
			}
			h3 {
				margin-top: j(100);
				margin-bottom: j(8);
				color: #54585a;
				font-size: j(36);
			}
			p {
				margin-bottom: j(100);
				// color: #999999;
				color: #9B9DA9;
				font-size: j(28);
			}
			span {
				// color: #999999;
				color: #9B9DA9;
				font-size: j(26);
				padding: j(16) j(34);
				letter-spacing: j(2);
				border: 1px solid #dcdcdc;
				border-radius: j(45);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/construct.vue